import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import DiscountVerify from "@/components/DiscountVerify";
import { ArrowLeft, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import Logo from "@/components/Logo";
import { useReceiptVerification } from "@/components/verify/useReceiptVerification";
import { ReceiptLookupCard } from "@/components/verify/ReceiptLookupCard";
import { ReceiptResult } from "@/components/verify/ReceiptResult";
import StorePendingReceipts from "@/components/verify/StorePendingReceipts";

const MODES = [["receipt", "Ricevuta premio"], ["discount", "Codice sconto"]];

export default function VerifyReceipt() {
  const navigate = useNavigate();
  const v = useReceiptVerification();
  const [scanning, setScanning] = useState(false);
  const [verifyMode, setVerifyMode] = useState("receipt");
  const [quickOtp, setQuickOtp] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/80 border-b border-border">
        <div className="max-w-2xl mx-auto px-6 py-4 flex items-center gap-3">
          <Button data-testid="verify-back-button" variant="ghost" size="icon" onClick={() => navigate("/")}>
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <Logo className="h-10" />
          <div>
            <h1 className="font-display font-bold text-xl">Verifica Ricevuta</h1>
            <p className="text-xs text-muted-foreground">Punto vendita · controllo e ritiro premi</p>
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-6 py-8 space-y-5" data-testid="verify-page">
        {v.store === undefined && <p className="text-muted-foreground">Caricamento…</p>}
        {v.store === null && <Navigate to="/login?tab=sede" replace />}
        {v.store && (
          <>
            <div className="grid grid-cols-2 gap-2" data-testid="verify-mode-switch">
              {MODES.map(([m, l]) => (
                <button key={m} type="button" data-testid={`verify-mode-${m}`} onClick={() => setVerifyMode(m)} className={`rounded-md border px-3 py-2 text-sm ${verifyMode === m ? "border-primary bg-primary/10" : "border-border"}`}>{l}</button>
              ))}
            </div>
            {verifyMode === "discount" && <DiscountVerify onAuthError={v.handleAuthError} onOpenReceipt={(s) => { setQuickOtp(true); setVerifyMode("receipt"); v.lookup(s); }} />}
            {verifyMode === "receipt" && <StorePendingReceipts />}
            <ReceiptLookupCard store={v.store} serial={v.serial} setSerial={v.setSerial} lookup={v.lookup} busy={v.busy} logout={v.logout}
              scanning={scanning} setScanning={setScanning} hidden={verifyMode === "discount"} />

            {v.error && (
              <Card className="p-5 bg-destructive/10 border-destructive/40 flex items-center gap-3" data-testid="verify-error">
                <XCircle className="h-6 w-6 text-destructive shrink-0" />
                <p className="font-semibold">{v.error}</p>
              </Card>
            )}

            {v.receipt && (
              <ReceiptResult receipt={v.receipt} store={v.store} busy={v.busy} run={v.run} onRedeemed={v.setReceipt} onReset={() => { setQuickOtp(false); v.reset(); }} autoOtp={quickOtp} />
            )}
          </>
        )}
      </main>
    </div>
  );
}
